import Button from '@ulta/core/components/Button/Button';

export default Button;
